import React, { useCallback, useEffect, useState } from 'react'
import './left_menu.sass'
import { Routes } from '../../CreateRoutering/types'
import IconMenuBar, { IconMenuBarNew1 } from './IconMenuBar'
import OpenedMenu from './OpenedMenu'
import { ModalOpenedTy } from '../../Modal/types'
import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { AppStyle, BookMarkRoute, BookMarkRoutesParsedTy } from '../../../app/erp/types'

interface LeftMenuBaseProps {
    routes: Routes
    bookMarkParsed: BookMarkRoute[]
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}
interface LeftMenuProps extends LeftMenuBaseProps {
    appStyle?: TwinEmployeeParametersDict['appStyle']
}

const LeftMenu: React.FC<LeftMenuProps> = ({appStyle, routes, bookMarkParsed, bookMarkParsedDict}) => {
    const menus: Record<AppStyle, React.FC<LeftMenuBaseProps>> = {
        default: LeftMenuDefault, 
        new1: LeftMenuNew1
    }
    const Component = menus[appStyle || 'new1']
    return (<Component routes={routes} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkParsedDict}/>)
}


const LeftMenuDefault: React.FC<LeftMenuBaseProps> = ({ routes }) => {
    const { opened, setOpened, resizeLeftMenu } = useLeftMenuDefaultLogic()
    const props = { routes, opened, setOpened }    
    return (
        <div className='flex'>
            <IconMenuBar {...props} onClick={resizeLeftMenu} />
            <OpenedMenu {...props} onClick={resizeLeftMenu} />
        </div>
    )
}

const useLeftMenuDefaultLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(true)

    const resizeLeftMenu = useCallback(() => {
        setOpened(window.innerWidth > 1100 ? true : null)
    }, [])

    useEffect(() => {
        resizeLeftMenu()
        window.addEventListener('resize', resizeLeftMenu)
        return () => {
            window.removeEventListener('resize', resizeLeftMenu)
        }
    }, [resizeLeftMenu])

    return { opened, setOpened, resizeLeftMenu }
}

const LeftMenuNew1: React.FC<LeftMenuBaseProps> = ({routes, bookMarkParsed, bookMarkParsedDict}) => {
    return (
        <div className='flex'>
            <IconMenuBarNew1 routes={routes} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkParsedDict} />            
        </div>
    )
}



export default LeftMenu